module.exports = __webpack_public_path__ + "img/card_banner5.816ef96e.svg";